import { BuildType } from './ApiService';
import {
    InstitutionFilters,
    InstitutionModel,
    InstitutionsResponse,
    QueryInstitutionParams,
} from '@/types/Institution';
import { MajorModel } from '@/ApiTypes.ts';

export const institutionApiEndpoints = (build: BuildType) => ({
    institutions: build.query<InstitutionsResponse, QueryInstitutionParams>({
        query: params => ({
            url: 'institutions/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: InstitutionsResponse) => response,
    }),
    institutionDetails: build.query<InstitutionModel, string>({
        query: id => `institutions/${id}`,
    }),
    institutionDetailsByOccupation: build.query<{ institution: InstitutionModel | undefined; majors: MajorModel[] }, { occupationId: string; institutionId: string }>({
        query: ({ occupationId, institutionId }) => `institutions/${institutionId}/occupations/${occupationId}/`,
        transformResponse: (response: { institution: InstitutionModel | undefined; majors: MajorModel[] }) => response,
    }),
    favoriteInstitution: build.mutation<void, string>({
        query: id => ({
            url: `user-institutions/${id}/favorite`,
            method: 'POST',
        }),
        invalidatesTags: ['Favorites'],
    }),
    institutionFilters: build.query<InstitutionFilters, string>({
        query: occupationId => `institutions/available-filters/${occupationId}`,
    }),
});
